import { useEffect } from 'react';
import { Form, Input, Modal } from 'antd';
import { useUpdateChildTaskMutation, useUpdateChildSubTaskMutation } from '@/services/child-api';
import { useGetChildTaskStatusQuery } from '@/services/general-api';
import Select from '@/components/select';

const EditModal = ({ childId, task, refetch, onClose }) => {
  const { data: statusData, isLoading: loadingStatusData } = useGetChildTaskStatusQuery();
  const [updateTask, { isLoading }] = useUpdateChildTaskMutation();
  const [updateSubTaskStatus, { isUpdatingSub }] = useUpdateChildSubTaskMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (task) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [task, form]);

  const onFinish = async (values) => {
    try {
      if (task.isSubtask)
        await updateSubTaskStatus({
          childId,
          typeId: task.type.id,
          assignment: values.assignment,
          status: values.status.code,
        }).unwrap();
      else
        await updateTask({
          childId,
          status: values.status.code,
          body: {
            type: { id: task.type.id },
            note: values.note,
          },
        }).unwrap();

      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal
      title="Edit Task"
      open={!!task}
      okText="Save"
      confirmLoading={isLoading || isUpdatingSub}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} initialValues={task} onFinish={onFinish}>
        <Form.Item name={['status', 'code']} label="Status">
          <Select options={statusData} valueName="code" loading={loadingStatusData} />
        </Form.Item>
        {task && task.isSubtask ? (
          <Form.Item name="assignment" label="Assignment">
            <Input.TextArea autoSize={{ minRows: 3 }} />
          </Form.Item>
        ) : (
          <Form.Item name="note" label="Note">
            <Input.TextArea autoSize={{ minRows: 3 }} />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default EditModal;
